const FrameManagePage = () => {
  return <div>FrameManagePage</div>;
};

export default FrameManagePage;
